import { api } from '@/services';
import type { ListaItensPayload, ListaItensResponse } from '../types';
import { normalizeListaDocumentosItensResponse } from './normalizers';

export async function fetchListaDocumentosItens(
  payload: ListaItensPayload
): Promise<ListaItensResponse> {
  const response = await api.post<ListaItensResponse, ListaItensPayload>(
    'Documento/ListaDocumentosItens',
    payload
  );

  return normalizeListaDocumentosItensResponse(response);
}
